import { render, staticRenderFns } from "./HistoryDetail.vue?vue&type=template&id=e21d9be0&scoped=true"
import script from "./HistoryDetail.vue?vue&type=script&lang=js"
export * from "./HistoryDetail.vue?vue&type=script&lang=js"
import style0 from "./HistoryDetail.vue?vue&type=style&index=0&id=e21d9be0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21d9be0",
  null
  
)

export default component.exports